var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("p", [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("e-sign-package.messages.drageIntoOrder")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "draggable",
            {
              staticClass: "row sortable-collapse",
              attrs: {
                id: "e-sign-order-files-container",
                tag: "div",
                animation: 200,
                "ghost-class": "ghost",
                handle: ".collapse-handle",
              },
              model: {
                value: _vm.selectedDocumentsValues,
                callback: function ($$v) {
                  _vm.selectedDocumentsValues = $$v
                },
                expression: "selectedDocumentsValues",
              },
            },
            _vm._l(_vm.selectedDocumentsValues, function (document) {
              return _c(
                "div",
                {
                  key: document.documentId,
                  staticClass: "col-12 sortable-document",
                },
                [
                  _c("div", { staticClass: "sortable-row" }, [
                    _c(
                      "div",
                      { staticClass: "collapse-m m-0 document-type-list" },
                      [
                        _c("div", { staticClass: "collapse-m-header py-2" }, [
                          _c("div", { staticClass: "row align-items-center" }, [
                            _c("div", { staticClass: "col-auto" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "collapse-handle cursor-move ml-2",
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-bars text-light-gray bold",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "mb-0 font-sm text-light-gray bold d-inline",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm._f("truncateFileName")(
                                          document.fileName,
                                          _vm.fileNameMaxLength
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "mb-0 font-sm text-primary bold d-inline",
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(document.classificationType) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.selectedDocumentsValues.length > 1
                              ? _c("div", { staticClass: "col-auto d-flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "request-trash mr-4" },
                                    [
                                      _c("inline-prompt", {
                                        staticStyle: { "font-size": "0.8rem" },
                                        attrs: { "action-type": "delete" },
                                        on: {
                                          accept: function ($event) {
                                            return _vm.handleDelete(
                                              document.documentId
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }